export default {
  paged: {
    select: 'id,entity,entityId,isSuccessfulOperation,observations,operation,user,created,actor',
    searchSelect: ['user', 'observations', 'entity', 'entityId'],
    orderBy: 'created desc',
    expand: {
      environment: {
        select: 'name',
      },
    },
  },
  itemDetail: {
    select:
      'id,entity,entityId,isSuccessfulOperation,observations,operation,user,created,actor,entityDescription',
    expand: {
      environment: {
        select: 'name',
      },
    },
  },
};
